export default "__VITE_ASSET__Bkrl2AAh__"